module.exports = __webpack_public_path__ + "img/absent.f73561fb.svg";